import * as React from 'react'
import { Box, Chip, Tooltip } from '@mui/material'
import GroupsRoundedIcon from '@mui/icons-material/GroupsRounded'

export default function TroopStockUnitChip({ unit, amountLabel }) {
    const iconUrl = String(unit?.iconUrl ?? '').trim()
    const [failedUrl, setFailedUrl] = React.useState('')
    const label = `${unit.label}: ${amountLabel}`
    const image = iconUrl && failedUrl !== iconUrl ? (
        <Box component="img" src={iconUrl} alt={unit.label} loading="lazy"
            onError={() => setFailedUrl(iconUrl)}
            sx={{ width: 28, height: 28, objectFit: 'contain', flexShrink: 0 }} />
    ) : <GroupsRoundedIcon aria-label={unit.label} sx={{ width: 24, height: 24, color: 'text.secondary' }} />
    return (
        <Tooltip title={unit.label}>
            <Chip data-testid={`troop-unit-${unit.unitID}`} size="small"
                avatar={<Box sx={{ display: 'grid', placeItems: 'center' }}>{image}</Box>}
                label={label}
                sx={{ height: 'auto', minHeight: 34, maxWidth: '100%', py: 0.2,
                    '& .MuiChip-avatar': { width: 28, height: 28, ml: 0.4, borderRadius: 0, backgroundColor: 'transparent' },
                    '& .MuiChip-label': { py: 0.35, px: 0.8, fontSize: '0.7rem', fontWeight: 700, whiteSpace: 'normal', overflowWrap: 'anywhere' } }} />
        </Tooltip>
    )
}
